import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';

// Pages
import MemberDashboard from './pages/member-dashboard';
import CommunityForums from './pages/community-forums';
import ProgressTracking from './pages/progress-tracking';
import EventsAndWorkshops from './pages/events-and-workshops';
import MemberProfile from './pages/member-profile';
import WellnessMarketplace from './pages/wellness-marketplace';
import LoyaltyWallet from './pages/loyalty-wallet';
import NotFound from './pages/NotFound';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<MemberDashboard />} />
          <Route path="/member-dashboard" element={<MemberDashboard />} />
          <Route path="/community-forums" element={<CommunityForums />} />
          <Route path="/progress-tracking" element={<ProgressTracking />} />
          <Route path="/events-and-workshops" element={<EventsAndWorkshops />} />
          <Route path="/member-profile" element={<MemberProfile />} />
          <Route path="/wellness-marketplace" element={<WellnessMarketplace />} />
          <Route path="/loyalty-wallet" element={<LoyaltyWallet />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
